import { createApp } from 'vue'
import App from './App.vue'

//import { LMap, LTileLayer, LMarkerCluster, LLayerGroup } from "@vue-leaflet/vue-leaflet";
//import { LMap, LTileLayer, LLayerGroup } from "@vue-leaflet/vue-leaflet";
//import { LMarkerCluster} from "leaflet.markercluster";
import A from './license.js';
import Tarkan from './tarkan/tarkanConnector'
import Traccar from './tarkan/traccarConnector'
import store from "./store/index"

import KT from './tarkan/func/kt'
import './registerServiceWorker'
import i18n from './lang/index'
import routes from './routes.js'


import * as Sentry from "@sentry/vue";


//import ElementPlus from "element-plus";

//import "element-plus/dist/index.css";

//import 'leaflet/dist/leaflet.css';
//import 'leaflet.markercluster/dist/MarkerCluster.css';
//import 'leaflet.markercluster/dist/MarkerCluster.Default.css';
//import 'leaflet.markercluster';

















const loc = window.location;

const serverUrl = loc.protocol+'//'+A[2]+'/api';
const tarkanUrl = loc.protocol+'//'+A[3]+'/tarkan';

window.$app = createApp(App).use(i18n).mixin({
    methods: {
        KT: KT
    }
}).use(store).use(Tarkan,tarkanUrl).use(Traccar,serverUrl).use(routes);
//window.$app.config.compilerOptions.isCustomElement = tag => tag.startsWith('LMarkerCluster');


Sentry.init({
    App: window.$app,
    dsn: "https://deb136f56dcff0e0670408b69ea21319@o4508689514102784.ingest.us.sentry.io/4508689515085824",
    integrations: [
      Sentry.browserTracingIntegration({ router: routes }),
      Sentry.replayIntegration(),
    ],
    // Tracing
    tracesSampleRate: 0, //  Capture 100% of the transactions
    // Session Replay
    replaysSessionSampleRate: 0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });

window.$app.mount('#app');





/*


import ElInput from "element-plus/es/components/input";
import ElButton from "element-plus/es/components/button";
import ElDialog from "element-plus/es/components/dialog";
import {ElSelect,ElOption} from "element-plus/es/components/select";
import {ElTabs,ElTabPane} from "element-plus/es/components/tabs";

import ElDatePicker from "element-plus/es/components/date-picker";
import ElSwitch from "element-plus/es/components/switch";
import ElCheckbox from "element-plus/es/components/checkbox";
import ElSlider from "element-plus/es/components/slider";
import ElColorPicker from "element-plus/es/components/color-picker";
import {ElForm,ElFormItem} from "element-plus/es/components/form";

import ElUpload from "element-plus/es/components/upload"

import {ElDropdown,ElDropdownItem,ElDropdownMenu} from "element-plus/es/components/dropdown";

import ElRadio from "element-plus/es/components/radio";
import ElTooltip from "element-plus/es/components/tooltip";




import 'element-plus/es/components/button/style/css'
import 'element-plus/es/components/input/style/css'
import 'element-plus/es/components/dialog/style/css'
import 'element-plus/es/components/message/style/css'
import 'element-plus/es/components/message-box/style/css'
import 'element-plus/es/components/notification/style/css'
import 'element-plus/es/components/tabs/style/css'
import 'element-plus/es/components/tab-pane/style/css'
import 'element-plus/es/components/select/style/css'
import 'element-plus/es/components/option/style/css'
import 'element-plus/es/components/date-picker/style/css'
import 'element-plus/es/components/switch/style/css'
import 'element-plus/es/components/checkbox/style/css'
import 'element-plus/es/components/slider/style/css'
import 'element-plus/es/components/color-picker/style/css'
import 'element-plus/es/components/form-item/style/css'
import 'element-plus/es/components/upload/style/css'

import 'element-plus/es/components/dropdown/style/css'
import 'element-plus/es/components/dropdown-item/style/css'
import 'element-plus/es/components/dropdown-menu/style/css'

import 'element-plus/es/components/radio/style/css'
import 'element-plus/es/components/tooltip/style/css'

window.$app.use(ElInput);
window.$app.use(ElButton);
window.$app.use(ElDialog);
window.$app.use(ElOption);
window.$app.use(ElSelect);
window.$app.use(ElTabPane);
window.$app.use(ElTabs);
window.$app.use(ElDatePicker);
window.$app.use(ElSwitch);
window.$app.use(ElCheckbox);
window.$app.use(ElSlider);

window.$app.use(ElColorPicker);
window.$app.use(ElForm);
window.$app.use(ElFormItem);
window.$app.use(ElUpload);

window.$app.use(ElDropdown);
window.$app.use(ElDropdownItem);
window.$app.use(ElDropdownMenu);

window.$app.use(ElRadio);
window.$app.use(ElTooltip);
*/


